module.exports = __webpack_public_path__ + "img/ic_sign_up_username.c645380c.svg";